import { Table } from "@/features/Table";
import { type Permission, permissions_columns } from "./columns";
import { type FilterPermissionsSchema, FilterPermissions } from "./filter";
import { useLocation } from "react-router-dom";

const client = "legacy-quantilia";
const table_name = "permissions";

export const PermissionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Permission, FilterPermissionsSchema>
      label="Permissions"
      client={client}
      table_name={table_name}
      columns={permissions_columns}
      filter={<FilterPermissions />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
